export const teamMembers = [
  {
    name: 'Ayodeji Balogun',
    role: 'Country Manager',
    imageSrc: 'team/team-member-1.png',
  },
  {
    name: 'Iruansi Itoandon',
    role: 'Commercial Manager',
    imageSrc: 'team/team-member-2.png',
  },
  {
    name: 'Akinyinka Akintunde',
    role: 'Business Development Manager',
    imageSrc: 'team/team-member-3.png',
  },
  {
    name: 'Isioma Oride',
    role: 'Internal Control and Compliance Manager',
    imageSrc: 'team/team-member-4.png',
  },
  {
    name: 'Nancy Ochonwe',
    role: 'Trading Manager',
    imageSrc: 'team/team-member-5.png',
  },
  {
    name: 'Oguntunde Joseph',
    role: 'Sales Operations Manager',
    imageSrc: 'team/team-member-6.png',
  },
  {
    name: 'Derin Adeola',
    role: 'Product Development Manager',
    imageSrc: 'team/team-member-7.png',
  },
  {
    name: 'Kamaldeen Raji',
    role: 'National Sales Manager',
    imageSrc: 'team/team-member-8.png',
  },
];
